import { request } from "../../../shared/utils";
import { METHODS, API } from "../../../shared/constants";
import { LandingStateType } from "../interfaces";

export default {
  getLandingSettings: (subdomain: string) => request(METHODS.GET, API.COMMUNITY_LANDING(subdomain))(),
  loadLandingEvents: ({ community_id, params }: { community_id: number; params: LandingStateType["params"] }) =>
    request(METHODS.GET, API.COMMUNITY_LANDING_EVENTS(community_id))({ params }),
};
